import {
  AdminPanelSettings,
  Feedback,
  FilePresent,
  Newspaper
} from '@mui/icons-material'
import { Box, Fade, Icon, Paper, Typography, Zoom } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { connect } from 'react-redux'
import { DocumentsAdmin, NewsAdmin, UserAdmin } from 'components/admin'
import ReportAdmin from 'components/admin/report-admin'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const AdminFC: React.FC<any> = (props: AppProps) => {
  const allTabsClosed = {
    user: false,
    news: false,
    documents: false,
    report: false
  }

  const [openTab, setOpenTab] = React.useState(allTabsClosed)
  const isMobileView = useMediaQuery('(max-width:900px)')

  return (
    <Fade in={true} timeout={1000}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        width={1}
        minHeight={'100vh'}
        sx={{ transition: '.5s' }}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Box width={1}>
          <Box
            width={1}
            height={
              JSON.stringify(openTab) === JSON.stringify(allTabsClosed)
                ? '0px'
                : 'initial'
            }
            sx={{ transition: '0.5s' }}
          >
            <Zoom in={openTab.user} exit={!openTab.user} unmountOnExit>
              <Box width={1}>
                <UserAdmin
                  onCloseContent={() => setOpenTab({ ...openTab, user: false })}
                />
              </Box>
            </Zoom>
            <Zoom in={openTab.news} exit={!openTab.news} unmountOnExit>
              <Box>
                <NewsAdmin
                  onCloseContent={() => setOpenTab({ ...openTab, news: false })}
                />
              </Box>
            </Zoom>
            <Zoom
              in={openTab.documents}
              exit={!openTab.documents}
              unmountOnExit
            >
              <Box>
                <DocumentsAdmin
                  onCloseContent={() =>
                    setOpenTab({ ...openTab, documents: false })
                  }
                />
              </Box>
            </Zoom>
            <Zoom in={openTab.report} exit={!openTab.report} unmountOnExit>
              <Box>
                <ReportAdmin
                  onCloseContent={() =>
                    setOpenTab({ ...openTab, report: false })
                  }
                />
              </Box>
            </Zoom>
          </Box>
          <Grid2 container justifyContent={'center'} alignItems={'center'}>
            <Grid2 sm={12} md={6}>
              <Box width={1} display={'flex'} justifyContent={'center'}>
                <Zoom
                  in={JSON.stringify(openTab) === JSON.stringify(allTabsClosed)}
                  exit={
                    JSON.stringify(openTab) !== JSON.stringify(allTabsClosed)
                  }
                  timeout={{ enter: 1000, exit: 0 }}
                  unmountOnExit
                >
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: 8,
                      padding: isMobileView ? 0 : 4,
                      margin: isMobileView ? 2 : 4,
                      marginLeft: isMobileView ? 2 : 'auto',
                      width: 'fit-content',
                      transition: '0.5s !important',
                      ':hover': {
                        borderRadius: 12
                      }
                    }}
                  >
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      sx={{
                        cursor: 'pointer'
                      }}
                      padding={4}
                      onClick={() => setOpenTab({ ...openTab, user: true })}
                    >
                      <Icon sx={{ fontSize: 200 }}>
                        <AdminPanelSettings fontSize={'inherit'} />
                      </Icon>
                      <Typography variant={'h3'}>User</Typography>
                    </Box>
                  </Paper>
                </Zoom>
              </Box>
            </Grid2>
            <Grid2 sm={12} md={6}>
              <Box
                width={1}
                display={'flex'}
                justifyContent={!isMobileView ? 'flex-start' : 'center'}
              >
                <Zoom
                  in={JSON.stringify(openTab) === JSON.stringify(allTabsClosed)}
                  exit={
                    JSON.stringify(openTab) !== JSON.stringify(allTabsClosed)
                  }
                  timeout={{ enter: 1000, exit: 0 }}
                  unmountOnExit
                >
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: 8,
                      padding: isMobileView ? 0 : 4,
                      margin: isMobileView ? 2 : 4,
                      width: 'fit-content',
                      transition: '0.5s !important',
                      ':hover': {
                        borderRadius: 12
                      }
                    }}
                  >
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      sx={{ cursor: 'pointer' }}
                      padding={4}
                      onClick={() => setOpenTab({ ...openTab, news: true })}
                    >
                      <Icon sx={{ fontSize: 200 }}>
                        <Newspaper sx={{ fontSize: 200 }} />
                      </Icon>
                      <Typography variant={'h3'}>News</Typography>
                    </Box>
                  </Paper>
                </Zoom>
              </Box>
            </Grid2>
            <Grid2 sm={12} md={6}>
              <Box width={1} display={'flex'} justifyContent={'center'}>
                <Zoom
                  in={JSON.stringify(openTab) === JSON.stringify(allTabsClosed)}
                  exit={
                    JSON.stringify(openTab) !== JSON.stringify(allTabsClosed)
                  }
                  timeout={{ enter: 1000, exit: 0 }}
                  unmountOnExit
                >
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: 8,
                      padding: isMobileView ? 0 : 4,
                      margin: isMobileView ? 2 : 4,
                      marginLeft: isMobileView ? 2 : 'auto',
                      width: 'fit-content',
                      transition: '0.5s !important',
                      ':hover': {
                        borderRadius: 12
                      }
                    }}
                  >
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      sx={{ cursor: 'pointer' }}
                      padding={4}
                      onClick={() =>
                        setOpenTab({ ...openTab, documents: true })
                      }
                    >
                      <Icon sx={{ fontSize: 200 }}>
                        <FilePresent sx={{ fontSize: 200 }} />
                      </Icon>
                      <Typography variant={'h4'}>Documents</Typography>
                    </Box>
                  </Paper>
                </Zoom>
              </Box>
            </Grid2>
            <Grid2 sm={12} md={6}>
              <Box
                width={1}
                display={'flex'}
                justifyContent={!isMobileView ? 'flex-start' : 'center'}
              >
                <Zoom
                  in={JSON.stringify(openTab) === JSON.stringify(allTabsClosed)}
                  exit={
                    JSON.stringify(openTab) !== JSON.stringify(allTabsClosed)
                  }
                  timeout={{ enter: 1000, exit: 0 }}
                  unmountOnExit
                >
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: 8,
                      padding: isMobileView ? 0 : 4,
                      margin: isMobileView ? 2 : 4,
                      width: 'fit-content',
                      transition: '0.5s !important',
                      ':hover': {
                        borderRadius: 12
                      }
                    }}
                  >
                    <Box
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      sx={{ cursor: 'pointer' }}
                      padding={4}
                      onClick={() => setOpenTab({ ...openTab, report: true })}
                    >
                      <Icon sx={{ fontSize: 200 }}>
                        <Feedback sx={{ fontSize: 200 }} />
                      </Icon>
                      <Typography variant={'h4'}>Reports</Typography>
                    </Box>
                  </Paper>
                </Zoom>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const Admin = connect(mapStateToProps, mapDispatchToProps)(AdminFC)

export default Admin
